const MapPinpoint = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_131_21952)">
        <path
          d="M7.99953 8.48008C7.83713 8.48008 7.67713 8.47032 7.51953 8.45288V15.0401C7.51953 15.1281 7.59153 15.2001 7.67953 15.2001H8.31953C8.40753 15.2001 8.47953 15.1281 8.47953 15.0401V8.45288C8.32193 8.47032 8.16193 8.48008 7.99953 8.48008Z"
          fill="#E92C2C"
        />
        <path
          d="M7.99965 0.800049C6.14397 0.800049 4.63965 2.30437 4.63965 4.16005C4.63965 6.01573 6.14397 7.52005 7.99965 7.52005C9.85533 7.52005 11.3596 6.01573 11.3596 4.16005C11.3596 2.30437 9.85533 0.800049 7.99965 0.800049ZM6.55965 4.64005C6.02941 4.64005 5.59965 4.21029 5.59965 3.68005C5.59965 3.14981 6.02941 2.72005 6.55965 2.72005C7.08989 2.72005 7.51965 3.14981 7.51965 3.68005C7.51965 4.21029 7.08989 4.64005 6.55965 4.64005Z"
          fill="#E92C2C"
        />
      </g>
      <defs>
        <clipPath id="clip0_131_21952">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapPinpoint;
